export default __webpack_public_path__ + "static/media/501.ecbb0caf.png";